var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { typography, fontWeight, color } from '../../constants';
var AvatarContainer = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  height: 48px;\n  width: 48px;\n  padding: 0;\n\n  border: 0;\n  /* TODO - this should be configurable when using an instance\n  of the Avatar component and be 'transparent' by default */\n  background-color: ", ";\n\n  color: ", ";\n  ", "\n  font-weight: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  svg {\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  height: 48px;\n  width: 48px;\n  padding: 0;\n\n  border: 0;\n  /* TODO - this should be configurable when using an instance\n  of the Avatar component and be 'transparent' by default */\n  background-color: ", ";\n\n  color: ", ";\n  ", "\n  font-weight: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  svg {\n    fill: ", ";\n  }\n"])), color.theme.primaryNav.state.currentActive, color.pureWhite, typography.displaySmall, fontWeight.bold, color.pureWhite);
/**
 * Return up to 3 initials from a name
 * @param name
 */
export function getInitials(name) {
    return name
        .split(' ')
        .slice(0, 3)
        .map(function (w) { var _a; return (_a = w[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase(); })
        .join('');
}
export var Avatar = function (_a) {
    var name = _a.name, icon = _a.icon, rest = __rest(_a, ["name", "icon"]);
    if ((name !== undefined && icon !== undefined) ||
        (name === undefined && icon === undefined)) {
        throw Error('Avatar expects one of "name" or "icon"');
    }
    return (React.createElement(AvatarContainer, __assign({}, rest),
        name !== undefined && getInitials(name),
        icon));
};
var templateObject_1;
//# sourceMappingURL=index.js.map